function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import { keyCodes, SliderMixin } from './slider-utils.js';
import { between } from '../../utils/format.js';
import { stopAndPrevent } from '../../utils/event.js';
export default Vue.extend({
  name: 'QSlider',
  mixins: [SliderMixin],
  props: {
    value: {
      required: true,
      "default": null,
      validator: function validator(v) {
        return typeof v === 'number' || v === null;
      }
    },
    labelValue: [String, Number]
  },
  data: function data() {
    var innerMin = this.__getInnerMin(this.innerMin);

    var innerMax = this.__getInnerMax(this.innerMax);

    return {
      model: this.value === null ? innerMin : between(this.value, innerMin, innerMax),
      curRatio: 0
    };
  },
  computed: {
    modelRatio: function modelRatio() {
      return this.__convertModelToRatio(this.model);
    },
    ratio: function ratio() {
      return this.active === true ? this.curRatio : this.modelRatio;
    },
    selectionBarStyle: function selectionBarStyle() {
      var _acc;

      var acc = (_acc = {}, _defineProperty(_acc, this.positionProp, "".concat(100 * this.innerMinRatio, "%")), _defineProperty(_acc, this.sizeProp, "".concat(100 * (this.ratio - this.innerMinRatio), "%")), _acc);

      if (this.selectionImg !== void 0) {
        acc.backgroundImage = "url(".concat(this.selectionImg, ") !important");
      }

      return acc;
    },
    thumbLabel: function thumbLabel() {
      return this.labelValue !== void 0 ? this.labelValue : this.model;
    },
    thumbClasses: function thumbClasses() {
      var color = this.thumbColor || this.color;
      return "q-slider__thumb q-slider__thumb".concat(this.axis, " q-slider__thumb").concat(this.axis, "-").concat(this.isReversed === true ? 'rtl' : 'ltr', " absolute non-selectable") + (this.preventFocus === false && this.focus === true ? ' q-slider--focus' : '') + (color !== void 0 ? " text-".concat(color) : '');
    },
    thumbStyle: function thumbStyle() {
      return _defineProperty({
        width: this.thumbSize,
        height: this.thumbSize
      }, this.positionProp, "".concat(100 * this.ratio, "%"));
    },
    thumbPinColor: function thumbPinColor() {
      return this.labelColor !== void 0 ? " text-".concat(this.labelColor) : '';
    },
    thumbTextContainerStyle: function thumbTextContainerStyle() {
      return this.__getTextContainerStyle(this.ratio);
    },
    thumbTextClass: function thumbTextClass() {
      return 'q-slider__text' + (this.labelTextColor !== void 0 ? " text-".concat(this.labelTextColor) : '');
    },
    trackContainerEvents: function trackContainerEvents() {
      if (this.editable !== true) {
        return {};
      }

      return this.$q.platform.is.mobile === true ? {
        click: this.__onMobileClick
      } : {
        mousedown: this.__onActivate,
        focus: this.__onFocus,
        blur: this.__onBlur,
        keydown: this.__onKeydown,
        keyup: this.__onKeyup
      };
    },
    trackContainerAttrs: function trackContainerAttrs() {
      return {
        tabindex: this.$q.platform.is.mobile !== true ? this.computedTabindex : null
      };
    },
    modelUpdate: function modelUpdate() {
      return "".concat(this.value, "|").concat(this.computedInnerMin, "|").concat(this.computedInnerMax);
    }
  },
  watch: {
    modelUpdate: function modelUpdate() {
      this.model = this.value === null ? this.computedInnerMin : between(this.value, this.computedInnerMin, this.computedInnerMax);
    }
  },
  methods: {
    __updateValue: function __updateValue(change) {
      if (this.model !== this.value) {
        this.$emit('input', this.model);
      }

      change === true && this.$emit('change', this.model);
    },
    __getDragging: function __getDragging() {
      return this.$el.getBoundingClientRect();
    },
    __updatePosition: function __updatePosition(event) {
      var dragging = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.dragging;

      var ratio = this.__getDraggingRatio(event, dragging);

      this.model = this.__convertRatioToModel(ratio);
      this.curRatio = this.snap !== true || this.computedStep === 0 ? ratio : this.__convertModelToRatio(this.model);
    },
    __onFocus: function __onFocus() {
      this.focus = true;
    },
    __onKeydown: function __onKeydown(evt) {
      if (!keyCodes.includes(evt.keyCode)) {
        return;
      }

      stopAndPrevent(evt);
      var step = ([34, 33].includes(evt.keyCode) ? 10 : 1) * this.computedStep,
          offset = ([34, 37, 40].includes(evt.keyCode) ? -1 : 1) * (this.isReversed === true ? -1 : 1) * step;
      this.model = between(parseFloat((this.model + offset).toFixed(this.computedDecimals)), this.computedInnerMin, this.computedInnerMax);

      this.__updateValue();
    }
  },
  render: function render(h) {
    var _this = this;

    var content = this.__getContent(h, function (node) {
      node.push(_this.__getThumb(h, {
        pinColor: _this.thumbPinColor,
        textContainerStyle: _this.thumbTextContainerStyle,
        textClass: _this.thumbTextClass,
        label: _this.thumbLabel,
        classes: _this.thumbClasses,
        style: _this.thumbStyle,
        nodeData: {}
      }));
    });

    return h('div', {
      "class": this.classes + (this.value === null ? ' q-slider--no-value' : ''),
      attrs: _objectSpread(_objectSpread({}, this.attributes), {}, {
        'aria-valuenow': this.value
      })
    }, content);
  }
});